import clsx from 'clsx';
import { fontFamilyRegular } from 'style/fonts';
import styled from 'styled-components';

export const ToggleBtn = ({
  onClick,
  isOn,
  thin = false,
  sm = false,
}: {
  onClick: (v: boolean) => void;
  isOn: boolean;
  thin?: boolean;
  sm?: boolean;
}) => {
  return (
    <ToggleButton
      onClick={(e) => onClick(!isOn)}
      className={clsx(thin ? 'thin' : '', sm ? 'sm' : '', isOn ? 'toggleOn' : 'toggleOff')}></ToggleButton>
  );
};

const ToggleButton = styled.button`
  position: relative;
  border-radius: 26px;
  width: 48px;
  height: 22px;
  background: #afbac7;

  &.thin {
    height: 18px;
    width: 40px;
  }

  &.sm {
    width: 36px;
    height: 16px;
  }

  span {
    font-size: 1.5rem;
    ${fontFamilyRegular};
    font-weight: 400;
    margin-left: 58px;
  }

  &:before {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    transition: left 250ms linear;
    top: calc(50% - 9px);
  }
  &.thin:before {
    width: 14px;
    height: 14px;
    top: calc(50% - 7px);
  }
  &.sm:before {
    width: 14px;
    height: 14px;
    top: calc(50% - 7px);
  }

  &.toggleOff {
    span {
      color: rgba(0, 0, 0, 0.35);
    }

    &:before {
      left: 2px;
      background-color: #e6eaef;
    }

    &.sm:before {
      left: 1px;
    }
  }

  &.toggleOn {
    background-color: #2b47a4;

    span {
      color: #374e92;
    }

    &:before {
      left: 28px;
      background-color: #fff;
    }
    &.thin:before {
      left: 24px;
    }
    &.sm:before {
      left: 21px;
    }
  }
`;
